
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 133.19 62.34"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"レイヤー_1","data-name":"レイヤー 1"}},[_c('g',{attrs:{"id":"logo"}},[_c('circle',{attrs:{"id":"circle","cx":"66.2","cy":"26.26","r":"23","fill":"none","stroke":"#1a1a1a","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{staticClass:"cls-2",attrs:{"d":"M66.51 53.68a26.84 26.84 0 1126.84-26.84 26.87 26.87 0 01-26.84 26.84zm0-45.57a18.73 18.73 0 1018.72 18.73A18.75 18.75 0 0066.51 8.11z","id":"center"}}),_c('path',{staticClass:"cls-2",attrs:{"d":"M62.45 39.87h8.11v22.47h-8.11z","id":"bar"}}),_c('g',{attrs:{"id":"left"}},[_c('path',{staticClass:"cls-2",attrs:{"id":"second","d":"M34.24 34.83L16.4 26.44l17.84-8.4v16.79z"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"first","d":"M23.36 37.44L0 26.44l23.36-11v22z"}})]),_c('g',{attrs:{"id":"right"}},[_c('path',{staticClass:"cls-2",attrs:{"id":"second-2","data-name":"second","d":"M98.95 34.83l17.84-8.39-17.84-8.4v16.79z"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"first-2","data-name":"first","d":"M109.82 37.44l23.37-11-23.37-11v22z"}})])])])])])
          )
        }
      }
    